import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop — resets window scroll to (0, 0) every time the route path
 * changes. Fixes the common SPA UX bug where clicking a link deep on the
 * current page keeps the new page scrolled to the same Y position.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
